module.exports = __webpack_public_path__ + "img/logo_oncogitiel.a1c99e21.png";